import * as React from 'react';
import clsx from 'clsx';
import { withTranslation, WithTranslation } from 'react-i18next';
import { AutoScrollbars } from 'components';
import { ILayerColumnJSON } from 'types/omjs/project';
import { FilesList } from './files-list';
import { ImagesList } from './images-list';

import './style.scss';


export interface IObjectMediaProps extends WithTranslation {
    object: omjs.IObjectJSON;
    imagesColumn: string | false;
    filesColumns: ILayerColumnJSON[];
    layerConfig: omjs.ILayerConfig;
    className?: string;
    layerCode: string | undefined
}
export interface IObjectMediaState {
    files: {[key: string]: {name: string, code: string, files: omjs.IObjectFieldValueFile[]}}
}

class ObjectMediaComponent extends React.Component<IObjectMediaProps, IObjectMediaState> {
    constructor(props: IObjectMediaProps) {
        super(props);
        this.state = {
            files: {}
        };
    }

    componentDidMount() {
        this.setFiles();
    }

    componentDidUpdate(prevProps: Readonly<IObjectMediaProps>, prevState: Readonly<IObjectMediaState>, snapshot?: any) {
        if (this.props.object.id !== prevProps.object.id) {
            this.setFiles();
        }
    }

    setFiles() {
        const { filesColumns, object } = this.props;
        const files = {};
        for (let column of filesColumns) {
            files[column.code] = {
                name: column.name || column.code,
                code: column.code,
                files: object.fields[column.code]
            };
        }
        this.setState({ files });
    }

    render() {
        let { imagesColumn, object, layerCode } = this.props;
        const { files } = this.state;

        let images = (
            typeof imagesColumn === 'string'
                ? object.fields[imagesColumn] as omjs.IObjectFieldValueFile[]
                : []
        );

        return (
            <AutoScrollbars className={this.props.className}>
                <div className={clsx('object-media-wrapper')}>
                    <div className="object-media-header-text">
                        {![ 'investment_projects', 'investment_projects_apk' ].includes(layerCode)
                            ? this.props.t('Медиа')
                            : this.props.t('Документы')}
                    </div>
                    <ImagesList images={images} />
                    <FilesList files={files} className='files-list-position' />
                </div>
            </AutoScrollbars>
        );
    }
}

export const ObjectMedia = withTranslation()(ObjectMediaComponent);
